import React from 'react';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';

interface BorderlessAccordionProps extends AccordionProps {
  toggleAtBottom?: boolean;
}

const BorderlessAccordionRoot = styled(Accordion, {
  shouldForwardProp: (prop) => prop !== 'toggleAtBottom',
})<BorderlessAccordionProps>(({ toggleAtBottom }) => ({
  display: 'flex',
  flexDirection: 'column',
  '&.MuiAccordion-root:before': {
    display: 'none',
  },
  ...(toggleAtBottom && {
    '& .MuiAccordion-region': { order: 1 },
    '& .MuiAccordionSummary-root': { order: 2 },
  }),
}));

export const BorderlessAccordion = React.forwardRef<
  HTMLDivElement,
  BorderlessAccordionProps
>((props, ref) => (
  <BorderlessAccordionRoot
    ref={ref}
    elevation={0}
    disableGutters={true}
    {...props}
  />
));

BorderlessAccordion.displayName = 'BorderlessAccordion';
